// Activate deferred theme/app resources consistently for every browser.
var script_loaded = false;
function loadJSscriptsNow() {
  if (script_loaded) return;
  script_loaded = true;
  document.querySelectorAll('script[data-src]').forEach(function (script) {
    script.setAttribute('src', script.getAttribute('data-src'));
    script.removeAttribute('data-src');
  });
  document.querySelectorAll('link[data-href]').forEach(function (link) {
    link.setAttribute('href', link.getAttribute('data-href'));
    link.removeAttribute('data-href');
  });
  setTimeout(function () {
    document.dispatchEvent(new CustomEvent('StartAsyncLoading'));
    document.dispatchEvent(new CustomEvent('StartKernelLoading'));
  }, 400);
}
function loadJSscripts() { loadJSscriptsNow(); }
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loadJSscriptsNow, { once: true });
} else {
  loadJSscriptsNow();
}
